import mixpanel from "mixpanel-browser";
import config from "../config";

export function initAnalytics() {
  console.log("Initializing analytics with token:", config.mixpanelToken);
  mixpanel.init(config.mixpanelToken, {
    debug: false,
    track_pageview: false,
    persistence: "localStorage",
  });
}

export function trackEvent(event: string, properties?: Record<string, string | number>) {
  mixpanel.track(event, properties);
}
